import { Box, Link, Typography } from "@mui/material";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkTitle from "../../components/atoms/TkTitle";
import { manualList } from "./parts";
import "./_style.scss";

/**
 * SCRW020001_ヘルプ
 * @returns SCRW020001_ヘルプ
 */
const SCRW020001 = () => {
  return (
    <Box className="SCRW020001">
      <TkInfoManual>{labelids.labelid.SCRW020001_01}</TkInfoManual>

      <Box className="field">
        {manualList.map((item, index) => (
          <Box key={index}>
            <TkTitle>■{item.title}</TkTitle>
            <TkInfoManual rule="\n">{item.index}</TkInfoManual>
            {item.detail && (
              <TkInfoManual rule="\n" className="detail">
                {item.detail}
              </TkInfoManual>
            )}
            <Box className="link">
              <Typography>{`>>`}</Typography>
              <Link
                href={`${process.env.PUBLIC_URL ?? ""}/assets/pdf/${item.link}`}
                target="_blank"
                rel="noreferrer"
              >
                {item.link}
              </Link>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SCRW020001;
